// extracted by mini-css-extract-plugin
module.exports = {"addFeedbackButtonContainer":"App_addFeedbackButtonContainer__24KmU"};